import React from "react";
import PropertyCard from "./PropertyCard";
import "./FeaturedProperties.css";
import contemporaryproperties1 from "../img/contemporaryproperties/contemporaryproperties1.png";
import contemporaryproperties2 from "../img/contemporaryproperties/contemporaryproperties2.png";
import contemporaryproperties3 from "../img/contemporaryproperties/contemporaryproperties3.png";
import contemporaryproperties4 from "../img/contemporaryproperties/contemporaryproperties4.png";

function FeaturedProperties() {
  return (
    <div className="FeaturedProperties">
      <div className="FeaturedProperties__title">
        <h1>New Contemporary elegance</h1>
      </div>
      <div className="FeaturedProperties__subtitle">
        <p></p>
      </div>
      <div className="FeaturedProperties__cards">
        <PropertyCard
          img="https://i.postimg.cc/HsjNvYLV/Frame-63.png"
          name="Modern Luxury Villa Project"
          location="Javea - SPAIN"
          price="950,000€"
          bedrooms="4"
          bathrooms="3"
          housesize="372 m²"
      status=""
         badgecolor=""
          slug="MODERN_LUXURY_VILLA_PROJECT_JAVEA_COSTA_BLANCA_SPAIN_CFP-P1076"
        />

        <PropertyCard
         img="https://i.postimg.cc/C5gT8W0w/Frame-63-1.png"
         name="Stunning Luxury Villa with Sea views"
         location="Moraira - SPAIN"
         price="1,725,000€"
         bedrooms="4"
         bathrooms="4"
         housesize="752 m²"
    status=""
         badgecolor=""
         slug="STUNNING_LUXURY_VILLA_WITH_SEA_VIEWS_IN_MORAIRA_CFP-M2009"
        />
        <PropertyCard
         img="https://i.postimg.cc/9F9J4JFQ/Frame-63-2.png"
         name="Luxury Modern Villa Project"
         location="Benitachell - SPAIN"
         price="770,000€"
         bedrooms="3"
         bathrooms="3"
         housesize="273 m²"
        status=""
         badgecolor=""
         slug="LUXURY_MODERN_VILLA_PROJECT_BENITACHELL_COSTA_BLANCA_SPAIN_CFP-P1008"
        />
        <PropertyCard
         img="https://i.postimg.cc/kGrrPDgJ/Frame-63-3.png"
         name="Luxury Villa - Marvilla"
         location="Calpe - SPAIN"
         price="1,550,000€"
         bedrooms="4"
         bathrooms="5"
         housesize="350 m²"
         status=""
         badgecolor=""
         slug="LUXURY_VILLA_MARYVILLA_CALPE_COSTA_BLANCA_SPAIN_CFP-P1012"
        />
      </div>
      <div className="FeaturedProperties__viewmore">
        <a href="/ModernProperties">
          <p>View more</p>
        </a>
      </div>
    </div>
  );
}

export default FeaturedProperties;
